import { appDispatcher } from '../../application/AppDispatcher'
import { namespacedConsts } from '../../utils/object'

const CLASS_CONSTATNTS = namespacedConsts({
  PUNDIT: {
    ACTIONS: {
      MATCH_STARTED: true,
      VOTE: true,
      FETCH_EXTERNAL_BETTING_PROVIDER: true,
      HYBRID_LOGIN: true,
      PLACE_BET: true,
    },
  },
})

export const TYPES = CLASS_CONSTATNTS.PUNDIT.ACTIONS

export const vote = (punditVbetObject, hybridRedirect) => {
  appDispatcher.dispatchAction.view({
    type: TYPES.VOTE,
    punditVbetObject,
    hybridRedirect,
  })
}
export const hybridLogin = () => {
  appDispatcher.dispatchAction.view({
    type: TYPES.HYBRID_LOGIN,
  })
}
export const fetchExternalBettingProvider = () => {
  appDispatcher.dispatchAction.view({
    type: TYPES.FETCH_EXTERNAL_BETTING_PROVIDER,
  })
}
export const matchStarted = () => {
  appDispatcher.dispatchAction.view({
    type: TYPES.MATCH_STARTED,
  })
}
export const placeBet = origin => {
  appDispatcher.dispatchAction.view({
    type: TYPES.PLACE_BET,
    origin,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/punditActions.js